import { queryKey } from 'Shared/const/queryKey';
import type { GetPointCountResponse } from 'viewup-api/v2';
import type { QueryParam } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';
import type { ViewingMoneyQueryKey } from './queries';

export const useGetEarnedPoints = (
  params?: QueryParam<
    GetPointCountResponse,
    unknown,
    GetPointCountResponse,
    ViewingMoneyQueryKey['earnedPoints']['queryKey']
  >,
) => {
  const queryResult = useSDQuery<
    GetPointCountResponse,
    unknown,
    GetPointCountResponse,
    ViewingMoneyQueryKey['earnedPoints']['queryKey']
  >({
    ...params?.options,
    ...queryKey.viewingMoney.earnedPoints,
  });

  return queryResult;
};
